import React, {Fragment, useState, useEffect} from 'react';
import FormsService from "../../../../services/FormsService";



const TemplateDPUAdresse = (props) => {

    const formService = new FormsService()
    const [address, setAddress]= useState([])
    const fetchData = formService.getAddressBien()

    useEffect(()=>{
        (fetchData)?setAddress(fetchData):null;
    },[fetchData])

    return (
        <div className="ue-section ue-adresse">
            <div style={{"width":"100%"}}>
                    <table className={"ue-form-table-base ue-form-table-row"} style={{"marginTop":"20px"}}>
                        <tbody>
                        <tr>
                            <td style={{"width":"120px"}}>Adresse du bien :</td>
                            <td><div id={"eu-adresse-bien"}>{address}</div></td>
                        </tr>
                        </tbody>
                    </table>
            <br/>
        </div>
        </div>
    );
};

export default TemplateDPUAdresse;
